import { render, staticRenderFns } from "./RegistrationSymbolColumn.vue?vue&type=template&id=c7e19f4c&"
import script from "./RegistrationSymbolColumn.vue?vue&type=script&lang=js&"
export * from "./RegistrationSymbolColumn.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationSymbolColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7e19f4c')) {
      api.createRecord('c7e19f4c', component.options)
    } else {
      api.reload('c7e19f4c', component.options)
    }
    module.hot.accept("./RegistrationSymbolColumn.vue?vue&type=template&id=c7e19f4c&", function () {
      api.rerender('c7e19f4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/RegistrationSymbolColumn.vue"
export default component.exports